import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: tetzla
 * id 825BA6A5-367F-42F8-A2B2-EBE84D7CBCF3
 * name flash-triangle-outline
 * version: 6.9.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/flash-triangle-outline.svg
 * tags
 * - Home Automation 
 */
export const FlashTriangleOutlineIcon = createSvgIcon(<><path d="M12 2L1 21H23M12 6L19.5 19H4.5M14 14H12.5L14 11H10V15H11V18L14 14Z" /></>, 'FlashTriangleOutlineIcon');
export default FlashTriangleOutlineIcon